import React from "react";

function Pesquisa({ texto, onTextoChange, onPesquisar }) {
  function handleKeyDown(e) {
    if (e.key === "Enter") {
      onPesquisar(texto);
    }
  }

  return (
    <div className="Pesquisa">
      <input
        type="text"
        placeholder="Buscar"
        value={texto}
        onChange={(e) => onTextoChange(e.target.value)}
        onKeyDown={handleKeyDown}
      />

      <button
        className="icone-lupa"
        onClick={() => onPesquisar(texto)}
        aria-label="Pesquisar"
      >
        <span className="material-symbols-outlined">
          search
        </span>
      </button>
    </div>
  );
}

export default Pesquisa;
